var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"create-data-page"}},[_c('h2',{staticClass:"intro-y text-lg font-medium mt-10"},[_vm._v(" 新增部/組/服務單位 ")]),(_vm.checkPermission(_vm.permissions, 'system.centre.create'))?_c('center-form'):(_vm.mounted)?_c('div',[_c('div',{staticClass:"alert alert-danger show mt-2",attrs:{"role":"alert"}},[_vm._v("沒有權限查看")])]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }